/**
 * Session reducer compatible with scratch-gui menu-bar expectations
 * (state.session.session.user / state.session.permissions).
 */

const SET_SESSION = 'scratch-hosted/session/SET_SESSION';
const CLEAR_SESSION = 'scratch-hosted/session/CLEAR_SESSION';

const initialState = {
    session: {}, // logged-out but session system available (shows Sign in / Join)
    permissions: {}
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_SESSION:
        return {
            session: action.session || {},
            permissions: action.permissions || {}
        };
    case CLEAR_SESSION:
        return {
            session: {},
            permissions: {}
        };
    default:
        return state;
    }
};

const setSession = (session, permissions) => ({
    type: SET_SESSION,
    session,
    permissions
});

const clearSession = () => ({
    type: CLEAR_SESSION
});

export {
    reducer as default,
    initialState as sessionInitialState,
    setSession,
    clearSession
};
